module.exports = __webpack_public_path__ + "static/icon-tech.1d9d7b2d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-tech.png
// module id = 988
// module chunks = 2